import { useState, useEffect } from 'react';
import { Download } from 'lucide-react';
import { Button } from '@/components/ui/button';

// Store the deferred prompt globally so it persists across component renders
let deferredPrompt = null;

export function useInstallApp() {
  const [canInstall, setCanInstall] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    // Check if already installed
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setIsInstalled(true);
      return;
    }

    // Check if on iOS (needs manual install instructions)
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    
    // Listen for the beforeinstallprompt event
    const handler = (e) => {
      e.preventDefault();
      deferredPrompt = e;
      setCanInstall(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    // Listen for successful install
    window.addEventListener('appinstalled', () => {
      setIsInstalled(true);
      setCanInstall(false);
      deferredPrompt = null;
    });

    // For iOS, we can show install button that opens instructions
    if (isIOS && !window.matchMedia('(display-mode: standalone)').matches) {
      setCanInstall(true);
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  const install = async () => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    
    if (isIOS) {
      // Show iOS instructions
      alert('Para instalar:\n\n1. Toca el botón de compartir (📤)\n2. Selecciona "Agregar a pantalla de inicio"');
      return false;
    }

    if (!deferredPrompt) {
      return false;
    }

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    
    if (outcome === 'accepted') {
      setIsInstalled(true);
      setCanInstall(false);
    }
    
    deferredPrompt = null;
    return outcome === 'accepted';
  };

  return { canInstall, isInstalled, install };
}


export function InstallAppButton({ className = '', variant = 'default', size = 'default' }) {
  const { canInstall, isInstalled, install } = useInstallApp();

  if (isInstalled || !canInstall) {
    return null;
  }

  return (
    <Button
      onClick={install}
      variant={variant}
      size={size}
      className={className}
    >
      <Download className="w-4 h-4 mr-2" />
      Instalar App
    </Button>
  );
}
